import React, { useState, useId } from 'react';
import './ThemeLabelPicker.css';

// Common teaching/rhetorical strategies a coach might reach for -
// suggestions only, the coach can type anything else too. Detecting these
// automatically would need real language understanding, not keyword
// matching, so this is a manual tag, not an auto-classifier.
const SUGGESTIONS = [
  'Hyperbole',
  'Parallelism',
  'Analogy',
  'Metaphor',
  'Repetition',
  'Rule of Three',
  'Storytelling',
  'Technical Explanation',
  'Rhetorical Question',
  'Contrast'
];

/**
 * "+ Tag strategy" control - lets a coach manually mark which teaching/
 * rhetorical device a moment uses. Same interaction shape as
 * ThemeLabelPicker (autocomplete + freeform), reusing its CSS.
 */
const RhetoricTagPicker = ({ existingTags = [], onTag }) => {
  const datalistId = useId();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = () => {
    setOpen(false);
    setValue('');
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const tag = value.trim();
    if (!tag || saving) return;

    setSaving(true);
    setError(null);
    try {
      await onTag(tag);
      setValue('');
      setOpen(false);
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.message || 'Failed to add tag');
    } finally {
      setSaving(false);
    }
  };

  const suggestions = SUGGESTIONS.filter(s => !existingTags.includes(s));

  if (!open) {
    return (
      <button type="button" className="theme-label-toggle" onClick={() => setOpen(true)}>
        + Tag strategy
      </button>
    );
  }

  return (
    <form className="theme-label-form" onSubmit={handleSubmit}>
      <input
        className="theme-label-input"
        list={datalistId}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="e.g. Hyperbole, Analogy..."
        autoFocus
        disabled={saving}
      />
      <datalist id={datalistId}>
        {suggestions.map(s => (
          <option key={s} value={s} />
        ))}
      </datalist>
      <button type="submit" className="theme-label-submit" disabled={saving || !value.trim()}>
        {saving ? '...' : 'Add'}
      </button>
      <button type="button" className="theme-label-cancel" onClick={handleClose} disabled={saving}>
        ✕
      </button>
      {error && <div className="theme-label-error">{error}</div>}
    </form>
  );
};

export default RhetoricTagPicker;
